import {
  Flex
} from '@chakra-ui/react';

const Error404Page = () => {
  return (
    <Flex>
      <h2>Error 404! Page not found</h2>
    </Flex>
  )
}

export default Error404Page;